module.exports = ($uibModal) ->
  return {
    restrict: 'A'
    scope:
      publishedDateModalButtonPublishedDate: '&'
      publishedDateModalButtonOnOk: '&'
    link: (scope, element) ->
      element.on 'click', ->
        publishedButtonModalInstance = $uibModal.open
          template: require("./published-date-modal.html")
          controller: require("./PublishedDateModalController")
          resolve:
            publishedDate: () -> scope.publishedDateModalButtonPublishedDate()
          size: "md"
        publishedButtonModalInstance.result.then (publishedDate) ->
          scope.publishedDateModalButtonOnOk({publishedDate: publishedDate})
  }
